module.exports = __webpack_public_path__ + "static/media/b.484d44fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/b.png
// module id = 1215
// module chunks = 0